import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { deleteAuth, updateSession } from '../../store/action-creators';
import { Auth as AuthEntity, Session } from '../../entities/auth';
import { Mortgage } from '../../entities/profile';
// material
import Hidden from '@material-ui/core/Hidden';
// components
import HeaderMenu from './HeaderMenu';
import ProfileMenu from './ProfileMenu';

const options = [
  'Products',
  'Affiliates',
  'Team',
  'Contact'
];

const styles = {
  nav: {
    listStyleType: 'none',
    margin: '5px 0 0 0',
    padding: 0,
    display: 'flex'
  },
  navItem: {
    paddingTop: 10,
    display: 'block',
    marginRight: 20,
    fontSize: 16
  },
  login: {
    color: '#00ADCB',
    paddingTop: 5,
    cursor: 'pointer'
  },
  profileIcon: {
    fontSize: 38
  }
}

interface HeaderNavProps {
  path: string;
  auth: AuthEntity;
  session: Session;
  onNavigate(route: string): void;
  onLogin(): void;
  deleteAuth(): void;
  updateSession(session: Session): void;
  onLogout(): void;
}

class HeaderNav extends React.Component<HeaderNavProps, {}> {
  
  isAdmin = () => {
    // todo: update to check roles here
    const auth = this.props.auth;
    const emails = [
      'jonathon.d.gray@gmail.com',
      'jay@micazza.com',
      'j.moulton@yahoo.com',
      'jaymoultonrealtor@gmail.com',
      'textadmin@galilaio.com'
    ]
    if (auth && auth.user && auth.user.email) {
      if (emails.indexOf(auth.user.email) !== -1) {
        return true;
      }
    }
    return false;
  }

  render() {
    return (
      <div>
        <ProfileMenu 
          isAdmin={this.isAdmin()}
          onClick={this.props.onNavigate} 
          onLogout={this.props.onLogout} 
        />
      </div>
    )
  }

}

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.auth,
    session: state.session.session
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ deleteAuth, updateSession }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderNav);


// WEBPACK FOOTER //
// ./src/components/header/HeaderNav.tsx